import React, { Component } from 'react';
import PropTypes from 'prop-types';
//import queryString from 'query-string';
import Header from '../components/Header';
import Tabs from '../components/Tabs';
import Tab from '../components/Tab';
import VendorListing from './VendorListing';
import VendorSuggestedOrders from './VendorSuggestedOrders';

import { AppContext } from '../context/AppContext'
import localize from '../hoc/localize';

class VendorOrderPage extends Component {


    static propTypes = {
        mode: PropTypes.oneOf(['suggestedPO', 'vendors']).isRequired,
        orgVendorID: PropTypes.string,
        vendorName: PropTypes.string,
        orderType: PropTypes.string
    }

    constructor(props) {
        super(props);
        this.divRef = React.createRef();

        this.state = {
            orgVendorID: null,
            vendorName: null,
            orderType: this.props.orderType,
            isNarrow: false,
            fontSize: 11,
        }
    };

    static getDerivedStateFromProps(nextProps, prevState) {

        if (nextProps.orderType !== prevState.orderType) {

            return {
                orderType: nextProps.orderType
            }

        }
        return null;
    }


    // click handler for individual cards
    handleChooseVendor = (orgVendorID, vendorName) => {
        this.setState({
            orgVendorID: orgVendorID,
            vendorName: vendorName
        });
    }
    getOrderTypeTitle = () => {
        let title = ''

        switch (parseInt(this.state.orderType, 10)) {
            case 1:
                title = this.props.returnLocalizedString("m0436")
                break;
            case 2:
                title = this.props.returnLocalizedString("m0437")
                break;
            default:
                title = this.props.returnLocalizedString("m0438")
        }
        return title;
    }

    handleResize = () => {
        var tabLength = 0;
        switch (this.props.mode) {
            case "vendors":
                tabLength = this.props.returnLocalizedString("m0004").length + this.props.returnLocalizedString("m0439", "", this.getOrderTypeTitle()).length;
                break;
            case "suggestedPO":
                tabLength = this.props.returnLocalizedString("m0004").length + this.props.returnLocalizedString("m0439", "", this.getOrderTypeTitle()).length + this.props.vendorName.length;
                break;
            default:
                break;
        }
        //console.log(window.innerWidth)
        if (window.innerWidth < 640) {
            this.setState({ isNarrow: true })
        }
        else {
            this.setState({ isNarrow: false })
        }
        const divElement = this.divRef.current;
        if (divElement) {
            const width = window.innerWidth;
            //console.log(width)

            // Adjust this factor as needed 
            //currently hardcoded for en and fr, but if more languages are added, each needs a new coef
            const coef = (this.props.uiLanguage === "fr") ? .95 : 1.05;
            const newSize = Math.min(11, coef * (width - 40) / tabLength);
            this.setState({ fontSize: newSize });
        }
    };

    componentDidMount = () => {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }

    componentWillUnmount = () => {
        window.removeEventListener('resize', this.handleResize);
    }


    render() {


        let content = (<div></div>);
        let tabs, title;
        let previousPageTitle;
        let previousPageUrl;
        let middleTab = this.state.isNarrow ? "m0573" : "m0439"


        switch (this.props.mode) {
            case "vendors":
                content = (<VendorListing handleChooseVendor={this.handleChooseVendor} orderType={this.state.orderType} />);

                tabs = (<Tabs>
                    <Tab fontSize = {`${this.state.fontSize}px`} label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
                    <Tab fontSize = {`${this.state.fontSize}px`} label={this.props.returnLocalizedString("m0439", "", this.getOrderTypeTitle())} ></Tab>
                </Tabs>);

                //title = "Suggested Order";
                title = this.props.returnLocalizedString("m0439", "", this.getOrderTypeTitle());

                break;
            case "suggestedPO":
                content = (<VendorSuggestedOrders orgVendorID={this.props.orgVendorID} orderType={this.state.orderType} />);
                tabs = (<Tabs>
                    <Tab fontSize = {`${this.state.fontSize}px`} label={this.props.returnLocalizedString("m0004")} link="/dashboard" ></Tab>
                    <Tab fontSize = {`${this.state.fontSize}px`} label={this.props.returnLocalizedString(middleTab, "", this.getOrderTypeTitle())} link={`/suggested-order/type/${this.state.orderType}`} ></Tab>
                    <Tab fontSize = {`${this.state.fontSize}px`} label={this.props.vendorName} ></Tab>
                </Tabs>);



                //previousPageTitle = {this.props.returnLocalizedString("m0004", "", this.getOrderTypeTitle())};
                //previousPageUrl = `/suggested-order/type/${this.state.orderType}`;
                title = this.props.returnLocalizedString("m0439", "", this.getOrderTypeTitle());
                //title = this.props.vendorName;

                break;
            default:
                break;
        }

        //!DBTRANS! @m0573@ SO - %var1% !DEVNOTE! Suggested Order abbreviation

        return (
            <div>
                <Header title={title} tabs={tabs} previousPageTitle={previousPageTitle} previousPageUrl={previousPageUrl} >

                </Header>

                <section ref={this.divRef} className="page-content grid-row">
                    {content}

                </section>
            </div>
        );
    }
}
VendorOrderPage.contextType = AppContext;

export default localize(VendorOrderPage);


// WEBPACK FOOTER //
// ./src/containers/VendorOrderPage.js